import React from 'react';
import { X, File, FileText, Image as ImageIcon, Film } from 'lucide-react';

const FilePreview = ({ attachment, typeOfMessage, onCancel }) => {
  const getFileIcon = () => {
    if (typeOfMessage.startsWith('image/')) {
      return <ImageIcon size={24} />;
    } else if (typeOfMessage.startsWith('video/')) {
      return <Film size={24} />;
    } else if (typeOfMessage.startsWith('application/pdf')) {
      return <File size={24} />;
    } else {
      return <FileText size={24} />;
    }
  };

  const renderPreview = () => {
    if (!attachment || (Array.isArray(attachment) && attachment.length === 0)) {
      return null;
    }
    if (Array.isArray(attachment)) {
      return attachment.map((file, index) => (
        <div key={index} style={{ marginBottom: '10px' }}>
          {typeOfMessage.startsWith('image/') ? (
            <img
              src={file}
              alt="Preview"
              style={{
                maxWidth: '200px',
                maxHeight: '200px',
                borderRadius: '8px',
                objectFit: 'contain',
              }}
            />
          ) : typeOfMessage.startsWith('video/') ? (
            <video
              controls
              style={{
                maxWidth: '200px',
                maxHeight: '200px',
                borderRadius: '8px',
              }}
            >
              <source src={file} type={typeOfMessage} />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px',
                background: '#404040',
                borderRadius: '8px',
              }}
            >
              {getFileIcon()}
              <span
                style={{
                  maxWidth: '150px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {file.split('/').pop()}
              </span>
            </div>
          )}
        </div>
      ));
    } else {
      // For other file types, show icon and filename
      return (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px',
          padding: '8px',
          background: '#404040',
          borderRadius: '8px'
        }}>
          {getFileIcon()}
          <span style={{ 
            maxWidth: '150px', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap' 
          }}>
            {attachment.split('/').pop()}
          </span>
        </div>
      );
    }
  };

  if (!attachment || (Array.isArray(attachment) && attachment.length === 0)) {
    return null;
  }

  return (
    <div style={{
      position: 'relative',
      margin: '10px',
      padding: '10px',
      background: '#2a2f32',
      borderRadius: '8px',
      border: '1px solid #404040'
    }}>
      <button
        onClick={onCancel}
        style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          background: '#404040',
          border: 'none',
          borderRadius: '50%',
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#e4e6eb'
        }}
      >
        <X size={16} />
      </button>
      {renderPreview()}
    </div>
  );
};

export default FilePreview;